import {Navigate, useLocation} from 'react-router-dom'
import React from "react";


const customerPaths = ['','case','module'];


export default function AuthCheck() {
    const path = useLocation().pathname.split('/')[1];

    let authorised = false;

    if (false && localStorage.getItem("token") == null) {
        authorised = false;
    } else {
        if (true || (localStorage.getItem("role") === "CUSTOMER" && customerPaths.includes(path))) {
            authorised = true;
        }
    }

    return authorised ? null : <Navigate to="/login" />;
}